import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { BdExportAsFileComponent } from '@bindoc-projects/export-as-file-lib/ui';
import { KostDataImportProcessorResultErrorExport } from '@bindoc-projects/kost-data-import-domain-lib';
import { TableModule } from 'primeng/table';
import { Message } from 'primeng/message';

@Component({
  selector: 'kost-data-import-new-dataset-input-result-errors',
  template: `
    <div class="section">
      <p-message severity="error">
        Ihr ausgewählter Datensatz konnte nicht verarbeitet werden
      </p-message>
    </div>
    <div>
      <div class="flex flex-row justify-end">
        <bd-export-as-file [data]="exportData" filename="KOST-Import_Fehler">
        </bd-export-as-file>
      </div>
      <p-table
        [value]="transformedErrors"
        [tableStyle]="{ 'min-width': '50rem' }"
      >
        <ng-template #header>
          <tr>
            <th>Datei</th>
            <th>Zeile</th>
            <th>Fehlermeldung</th>
          </tr>
        </ng-template>
        <ng-template #body let-error>
          <tr>
            <td>{{ error.file }}</td>
            <td>{{ error.line }}</td>
            <td>{{ error.message }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  `,
  styles: `
    .section {
      margin: 24px 0;
    }
  `,

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [BdExportAsFileComponent, TableModule, Message],
})
export class KostDataImportNewDatasetInputResultErrorsComponent implements OnInit {
  @Input()
  public errors: string[] = [];

  public exportData: KostDataImportProcessorResultErrorExport;
  public transformedErrors: { file: string; line: string; message: string }[] =
    [];

  private fileErrorRegex = new RegExp(
    'Fehler in Datei: ([A-Z]*) - Zeile (\\d*) - (.*)',
  );

  ngOnInit(): void {
    this.exportData = new KostDataImportProcessorResultErrorExport(this.errors);
    this.transformedErrors = this.errors.map((errorMessage) => {
      const patternMatch: RegExpMatchArray = errorMessage.match(
        this.fileErrorRegex,
      );

      if (patternMatch) {
        return {
          file: patternMatch[1],
          line: patternMatch[2],
          message: patternMatch[3],
          originalMessage: errorMessage,
        };
      } else {
        return {
          file: 'Allgemein',
          line: null,
          originalMessage: errorMessage,
          message: errorMessage,
        };
      }
    });
  }
}
